const maximumFileNameBytes = 255;

// Published element tilesets are named by this rule, so it must not change on its own.
export async function getElementTilesetFileName(elementId: string) {
  const rawFileName = `tileset-element-${elementId}.json`;
  if (!needsHashedFileName(elementId, rawFileName)) {
    return rawFileName;
  }

  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(elementId),
  );
  const hash = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
  return `tileset-element-sha256-${hash}.json`;
}

function needsHashedFileName(elementId: string, rawFileName: string) {
  return (
    /[/\\\u0000-\u001f\u007f]/.test(elementId) ||
    new TextEncoder().encode(rawFileName).length > maximumFileNameBytes
  );
}
